import React, { Component } from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';

import OverlayDialog from 'common/components/core/dialog/OverlayDialog';
import { HeaderAppBar } from 'common/components/core/app_bar/HeaderAppBar';
import theme from './AlertDialog.scss';
import { Button, ButtonTypes } from 'common/components/core/button';
import { dashboardColors } from 'common/enums/ColorEnum';

class AlertDialog extends Component {
    render() {
        const {
            theme,
            title,
            isOpen,
            className,
            cancelLabel,
            confirmLabel,
            onCancel,
            onConfirm,
            cancelButtonTestId,
            stayButtonTestId
        } = this.props;
        return (
            <OverlayDialog
                active={isOpen}
                theme={theme}
                dialogClassName={classnames(theme.dialog, {
                    [className]: className
                })}
                onEscapeClick={onCancel}
            >
                <div className={theme.dialogWrap}>
                    <HeaderAppBar theme={theme} flat title={title} />
                    <div className={theme.dialogContentWrap}>
                        <div className={theme.dialogContent}>
                            {this.props.children}
                        </div>
                        <div className={theme.dialogActions}>
                            <Button
                                theme={theme}
                                buttonType={ButtonTypes.Text}
                                semibold
                                uppercase
                                color={dashboardColors.slateGrey.name}
                                className={classnames(theme.actionBtn)}
                                label={cancelLabel}
                                onClick={onCancel}
                                data-test-id={cancelButtonTestId}
                            />
                            <Button
                                theme={theme}
                                buttonType={ButtonTypes.Text}
                                semibold
                                uppercase
                                color={dashboardColors.salmon.name}
                                className={classnames(theme.actionBtn)}
                                label={confirmLabel}
                                onClick={onConfirm}
                                autoFocus
                                data-test-id={stayButtonTestId}
                            />
                        </div>
                    </div>
                </div>
            </OverlayDialog>
        );
    }
}

export default themr('AlertDialog', theme)(AlertDialog);
